import React, { useState } from 'react'

function PostFormInfoModal() {
    const [open, setOpen] = useState(false)

    const openModal = () => {
        setOpen(true)
    }

    const cancel = () => {
        setOpen(false)
    }

  return (
    <div>
        <small className="form-text info-question-position" onClick={openModal}>
            Learn more about templates<i className="fas fa-question-circle mr-2 text-secondary-icon cursor-cu"></i>
        </small>

         {open &&
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                <div>
                    <h5><strong>How To Use Templates</strong></h5>
                    <div>
                        <p className="cu-template-info">
                            Templates are pre-saved posts that can be used to create new posts in a more efficient and scalable way. You can <i>save posts as templates<br/>
                            by checking the templates toggle</i> or you can <i>use a template from the posts page on a profile, or by typing similar content into a post and it will be auto suggested.</i>
                        </p>
                    </div>
                </div>

                <div>
                    <h5><strong>How To Use Template Variables</strong></h5>
                    <div>
                        <p className="cu-template-info">
                            Template Variables can be used to personalize post content for the audience by writing special syntax into a post's content (e.g <i>"Dear {"{{receiver.first_name}}"}).<br/>
                            The actual value will be seen by the audience when they view the post.</i>
                        </p>
                        <p className="cu-template-info">
                            <i>To use template variables enter two curly braces {'"{{"'} in the contents field and select the variable you would like to use.</i>
                        </p>
                    </div>
                </div>

                    <div className="pt-3">
                        <button onClick={cancel} type="button" className="btn btn-primary mr-2">
                            Close
                        </button>
                    </div>
                </div>
         </div>}
    </div>
  )
}

export default PostFormInfoModal